export default __webpack_public_path__ + "static/pict5Placeholder-2c048d8dd8fb577e5af36d86ee8e3167.png";